import React, { useEffect, useState } from "react";
import axios from 'axios';
import { API_BASE_URL } from "../../constant/constant";
import {
  Box,
  Card,
  CardContent,
  Typography,
  Button,
  Stack,
  useTheme,

} from "@mui/material";
import {
  
  Security,
  Settings,
  
} from "@mui/icons-material";


import SP_Notification from "./SuperUserDashBoard/SP_Notification";
import SP_ActiveUsers from "./SuperUserDashBoard/SP_ActiveUsers";
import SP_SystemHealth from "./SuperUserDashBoard/SP_SystemHealth";
import SP_Activity from "./SuperUserDashBoard/SP_Activity";
import SP_Analytics from "./SuperUserDashBoard/SP_Analytics";
import SP_StatCards from "./SuperUserDashBoard/SP_StatCards";
import SP_Button_ChangeSoftware from "./SuperUserDashBoard/SP_Button_ChangeSoftware";
import { Line } from "recharts";
import SP_Button_AddOrganisation from "./SuperUserDashBoard/SP_Button_AddOrganisation";

import EncryptDecryptTool from "../../components/EncryptDecryptTool";
import { decrypt } from "../../components/cryptoUtil";

export default function RIBDashBoard() {
const token = localStorage.getItem("token");

 const theme = useTheme();

 const [ribData,setRibData]=useState([]);

 const tokenData = JSON.parse(decrypt(localStorage.getItem("tokenData")));

  const fetchRibdata = async () => {
    try {
      const res = await axios.get(`${API_BASE_URL}/yearlyDrCrTotal` ,{headers: {
    'Content-Type': 'application/json',
     "Authorization": `Bearer ${token}`, // optional, set default headers
  },});
      const data = res.data || [];
      if (data.length > 0) setRibData(data[0]);
    } catch (err) {
      console.error("Error fetching Active Users", err);
    }
  };

useEffect(() => {
    fetchRibdata(); // initial fetch
}, []); // dependency if you want refetch when softgroup changes

const [showTool, setShowTool] = useState(false);
  return (
    <Box
      sx={{
        p: { xs: 1, sm: 2, md: 3 },
        bgcolor: theme.palette.mode === "light" ? "#f4f6f8" : "background.default",
        minHeight: "100vh",
      }}
    >
       
      {/* Active Users */}
       <SP_ActiveUsers />

 <SP_StatCards />
      {/* Charts + Timeline */}

      <Card sx={{ p: 2, mt: 3, borderRadius: 3, boxShadow: 3 }}>
        <Typography variant="h6" gutterBottom >
          📊 Analytics & Activity
        </Typography>
        
        
        <SP_Activity />

              <SP_Analytics data={ribData}
                            XAxisKey="year"
                            YAxis1="dramount"
                            YAxis2="creditamount"
                           // YAxis3="Expenses"
                            charts={["line", "bar", "area", "pie", "radar", "composed", "scatter"]}/>
      </Card>

      
      {/* Notifications Panel */}
      <SP_Notification />



 {tokenData.userrole === 999 && (
<>
                {/* System Health */ }
                < SP_SystemHealth />

                <Card sx={{ p: 2, borderRadius: 3, boxShadow: 3, mb: 3, mt: 3 }}>
                    <Typography variant="h6" gutterBottom>
                        🚀 Quick Actions
                    </Typography>
                    <Stack
                        direction={{ xs: "column", sm: "row" }}
                        spacing={2}
                        alignItems={{ xs: "stretch", sm: "center" }}
                    >
                        <SP_Button_ChangeSoftware />
                        <SP_Button_AddOrganisation />
                        <EncryptDecryptTool />
                    </Stack>
                </Card>
                </>
            )}



    </Box>
  );
}
